import React from 'react'
import { NavLink, Nav, NavLinkMenu, NavLinkLogo, MobileLogoBtn, NavMLHLink, MobileLogoImg } from './navbarElements';
import logo from '../../../../assets/images/logo/Qhackslogoblack_witharrow.png';
import logo2 from '../../../../assets/images/logo/qhacksCrown-black.svg';

import mlhlogo from '../../../../assets/images/logo/mlh-trust-badge-2022-black.svg';

const Navbar = ({toggle}) => {
    return (
        <>
            <Nav>
                <MobileLogoBtn onClick={toggle}>
                    <MobileLogoImg src={logo}  alt='LOGO' />
                </MobileLogoBtn>
                <NavLinkMenu>
                     <NavMLHLink href="https://mlh.io/seasons/2021/events?utm_source=na-hackathon&utm_medium=TrustBadge&utm_campaign=2021-season&utm_content=gray" target="_blank">
                        <img src={mlhlogo} alt='LOGO' style={{"width": "75px"}}/>
                    </NavMLHLink> 
                    <NavLink exact={true} to="/our-team" >
                        Our Team
                    </NavLink> 
                    <NavLink to="/schedule" >
                        Schedule
                    </NavLink> 
                    
                    <NavLink to="/speakers" >
                        Speakers
                    </NavLink>
                    
                    
                </NavLinkMenu>
                <NavLinkLogo to="/">
                    <img src={logo2} alt='LOGO'/>
                </NavLinkLogo>
                <NavLinkMenu>
                <NavLink to="/sponsors" >
                        Sponsors
                    </NavLink>
                    <NavLink to="/testimonials" >
                        Testimonials
                    </NavLink>
                    {/* <NavLink to="/our-team" >
                        Our Team
                    </NavLink> */}
                    {/* <NavLink to="/archive" >
                        Archive
                    </NavLink> */}
                    {/* <NavLink to="/faq" activeStyle>
                        FAQ
                    </NavLink> */}
                    <NavLink to="/contact-us" activeStyle>
                        Contact Us
                    </NavLink>
                    
                </NavLinkMenu>
            </Nav>
        </>
    )
}

export default Navbar;

